import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedService } from './shared.service';
import { TranslatePipe } from './pipes/translate.pipe';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [TranslatePipe],
    imports: [
        CommonModule,
        FormsModule
    ],
    exports: [CommonModule, FormsModule, TranslatePipe],
    providers: [SharedService]
})
export class SharedModule { }
